function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1-ap{fill:#1b1464}\r\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "ap-play_logo",
  transform: "translate(0 1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "ap-Path_943",
  d: "M33.779 22.5a2.935 2.935 0 0 0-.579 2.123v34.166a2.7 2.7 0 0 0 .772 2.123l.193.193L53.275 42v-.29z",
  className: "cls-1-ap",
  transform: "translate(-33.2 -22.008)"
}), /*#__PURE__*/React.createElement("path", {
  id: "ap-Path_944",
  d: "M60.17 48.922l-6.37-6.37v-.482l6.37-6.37.193.193 7.528 4.343c2.123 1.255 2.123 3.281 0 4.44z",
  className: "cls-1-ap",
  transform: "translate(-31.918 -22.469)"
}), /*#__PURE__*/React.createElement("path", {
  id: "ap-Path_945",
  d: "M59.569 49.066L53.1 42.6 33.8 61.9c.772.772 1.834.772 3.281.193l22.488-13.027",
  className: "cls-1-ap",
  transform: "translate(-32.221 -21.709)"
}), /*#__PURE__*/React.createElement("path", {
  id: "ap-Path_946",
  d: "M59.569 35.319L37.081 22.482a2.56 2.56 0 0 0-3.281.193l19.3 19.11 6.466-6.466z",
  className: "cls-1-ap",
  transform: "translate(-32.221 -22.991)"
}));

var SvgPlaystore = function SvgPlaystore(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37.565,
    height: 41.799,
    viewBox: "0 0 37.565 41.799",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlaystore, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/playstore.0c5d0b95.svg";
export { ForwardRef as ReactComponent };